/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * TK-27 (10/10/2026) — GIỮ DỮ LIỆU ĐANG NHẬP TRONG HỘP THOẠI.
 *
 * lee 10/10: *"Tôi sử dụng tablet nhập vô tình bấm vào khoảng trống thì tự động tắt giao diện
 * đang nhập, dữ liệu đang nhập mất hoàn toàn."*
 *
 * Trên máy tính bảng có BỐN đường làm một hộp nhập biến mất mà người dùng không định đóng:
 *   ① chạm nền mờ ngoài hộp      → hộp Fluent (Quản trị · tài khoản) đóng NGAY — đo được, đã tái hiện
 *   ② vuốt nhẹ xuống ở chỗ trống  → trình duyệt hiểu là "kéo để tải lại" → cả trang nạp lại
 *   ③ vuốt từ mép màn hình        → Android hiểu là "Quay lại" → rời trang, hộp mất theo trang
 *   ④ chạm trúng nút ✕ ở góc / Esc → đóng thật, không hỏi
 *
 * Luật chung từ bản này (mọi hộp có ô nhập):
 *   · chạm nền mờ KHÔNG BAO GIỜ đóng hộp                     (①)
 *   · khi hộp đang mở, trình duyệt KHÔNG "kéo để tải lại"     (②) — `useChanKeoTaiLai`
 *   · đã gõ gì đó mà bị "Quay lại" → ở yên, hỏi lại          (③) — `useGiuKhiLui`
 *   · đã gõ gì đó mà bấm ✕ / Esc → hỏi lại trước khi bỏ       (④) — ở chính hộp
 *   · đã gõ gì đó mà trang sắp nạp lại / đóng tab → trình duyệt hỏi — `useHoiKhiTaiLai`
 *   Nút "Huỷ" ghi chữ rõ ràng thì vẫn đóng ngay: đó là ý định nói ra, không phải tai nạn.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */

import { useEffect, useRef } from 'react';

/* ② — đếm số hộp đang mở: hộp lồng hộp chỉ trả lại thiết lập cũ khi hộp CUỐI đóng. */
let soHopMo = 0;
let cuHtml = '';
let cuBody = '';

export function useChanKeoTaiLai(mo: boolean): void {
  useEffect(() => {
    if (!mo) return;
    const h = document.documentElement;
    const b = document.body;
    if (soHopMo === 0) {
      cuHtml = h.style.overscrollBehaviorY;
      cuBody = b.style.overscrollBehaviorY;
      h.style.overscrollBehaviorY = 'none';
      b.style.overscrollBehaviorY = 'none';
    }
    soHopMo += 1;
    return () => {
      soHopMo -= 1;
      if (soHopMo === 0) {
        h.style.overscrollBehaviorY = cuHtml;
        b.style.overscrollBehaviorY = cuBody;
      }
    };
  }, [mo]);
}

/* Trang sắp nạp lại / đóng tab khi còn chữ chưa lưu → trình duyệt tự hỏi "Rời trang?". */
export function useHoiKhiTaiLai(bat: boolean): void {
  useEffect(() => {
    if (!bat) return;
    const f = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', f);
    return () => window.removeEventListener('beforeunload', f);
  }, [bat]);
}

/**
 * ③ — đã gõ thì đặt thêm MỘT bậc lịch sử cùng địa chỉ. "Quay lại" chỉ lùi khỏi bậc ấy (vẫn đúng
 * trang, hộp vẫn mở, chữ vẫn còn), ta đặt lại bậc và hỏi người dùng.
 *
 * ⚠ Bậc thêm chép NGUYÊN trạng thái lịch sử của bộ định tuyến (cùng số thứ tự) ⇒ khi lùi về,
 *   bộ định tuyến thấy "vẫn trang này", không dựng lại trang.
 * ⚠ Hộp đóng bình thường mà bậc của mình còn trên đỉnh ⇒ tự lùi một bậc cho sạch. Nếu sau khi
 *   lưu, trang đã đi tiếp sang chỗ khác thì đỉnh không còn là bậc của mình ⇒ KHÔNG lùi (lùi lúc ấy
 *   là kéo người dùng ngược khỏi trang họ vừa được đưa tới).
 */
export function useGiuKhiLui(bat: boolean, hoi: () => void): void {
  const hoiRef = useRef(hoi);
  hoiRef.current = hoi;
  useEffect(() => {
    if (!bat) return;
    const dau = `giu-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const datBac = () => {
      const cu = (window.history.state ?? {}) as Record<string, unknown>;
      window.history.pushState({ ...cu, kappGiuNhap: dau }, '');
    };
    datBac();
    const khiLui = () => {
      if ((window.history.state as { kappGiuNhap?: string } | null)?.kappGiuNhap === dau) return;
      datBac();
      hoiRef.current();
    };
    window.addEventListener('popstate', khiLui);
    return () => {
      window.removeEventListener('popstate', khiLui);
      if ((window.history.state as { kappGiuNhap?: string } | null)?.kappGiuNhap === dau) window.history.back();
    };
  }, [bat]);
}

/* Esc chỉ dành cho hộp TRÊN CÙNG — hộp hỏi lồng trên hộp nhập thì Esc không được đóng cả hai. */
const ngan: string[] = [];
export function vaoNgan(id: string): () => void {
  ngan.push(id);
  return () => { const i = ngan.lastIndexOf(id); if (i >= 0) ngan.splice(i, 1); };
}
export function laTrenCung(id: string): boolean {
  return ngan[ngan.length - 1] === id;
}

/** Câu hỏi lại — MỘT chỗ viết, hộp chung và hộp Fluent cùng đọc. */
export const CAU_HOI_BO_NHAP = {
  dau: 'Đóng hộp này?',
  than: 'Những gì bạn vừa nhập chưa được lưu và sẽ mất.',
  giu: 'Tiếp tục nhập',
  bo: 'Bỏ, đóng hộp',
} as const;
